import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {Observable} from "rxjs";
import {of} from "rxjs";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../store";
import {Config} from "../../config/config";
import {DEMO_POST_REQUESTS_LIST} from "./demo-post-requests-list";

@Injectable()
export class DemoRequestsInterceptor implements HttpInterceptor {

  constructor(
    private readonly _store: Store<DbStoreState>,
  ) {}


  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    return this.handleRequests(req, next);
  }

  handleRequests(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const baseUrl = request.url.split('?')[0];
    const hasEnding = DEMO_POST_REQUESTS_LIST.some((blockedUrls) => baseUrl.endsWith(blockedUrls));
    const isDemoWebsiteRequest = request.url.indexOf(Config.demoDomainId.toString()) > -1;

    if (hasEnding) {
      if (isDemoWebsiteRequest) {
        return of(new HttpResponse({url: 'stubUrl', status: 200, body: {message: 'stub request'}}));
      }
      return next.handle(request);
    }
    else {
      // if there is not any matches returns default request
      return next.handle(request);
    }
  }
}
